import { render, staticRenderFns } from "./Formltem.vue?vue&type=template&id=3532f89a&scoped=true&"
import script from "./Formltem.vue?vue&type=script&lang=ts&"
export * from "./Formltem.vue?vue&type=script&lang=ts&"
import style0 from "./Formltem.vue?vue&type=style&index=0&id=3532f89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532f89a",
  null
  
)

export default component.exports